module.exports = __webpack_public_path__ + "logo-tall-255c8f700b8946ad0352649645bfb56e.png";